module.exports = __webpack_public_path__ + "img/sign.aaa19202.png";